import React from 'react';
export default function Strong(props) {
    return React.createElement("strong", null, props.children);
}
//# sourceMappingURL=strong.js.map